export default __webpack_public_path__ + "static/media/property_435.dce1ff92.png";